import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function ProcessosList() {
  const [processos, setProcessos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/processos_list.php")
      .then(res => setProcessos(res.data))
      .catch(() => setProcessos([]));
  }, []);

  return (
    <AppLayout title="Processos">
      <div className="space-y-3">
        {processos.map(p => (
          <div
            key={p.id}
            onClick={() => navigate(`/app/admin/processos/${p.id}`)}
            className="cursor-pointer rounded-xl border border-[#1f2937] bg-[#121826] p-4 hover:bg-[#1a2233]"
          >
            <p className="text-sm font-semibold text-slate-100">
              {p.numero || "Processo interno"}
            </p>
            <p className="text-xs text-slate-400">
              {p.cliente} • {p.vara} • {p.status}
            </p>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
